module.exports = __webpack_public_path__ + "img/Image - Header 5.43e94c3a.png";